import { Component, OnInit, Input } from '@angular/core';
import { ModalDismissReasons, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'ref-ref-message-modal',
    templateUrl: './ref-message-modal.component.html',
    styleUrls: ['./ref-message-modal.component.scss'],
    standalone: false
})
export class RefMessageModalComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() buttons: any;

  constructor(protected modalService: NgbActiveModal) {}

  ngOnInit() {}

  public getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
